import { render, staticRenderFns } from "./ImageDetailsStepFour.vue?vue&type=template&id=4b5af929&scoped=true&"
import script from "./ImageDetailsStepFour.vue?vue&type=script&lang=js&"
export * from "./ImageDetailsStepFour.vue?vue&type=script&lang=js&"
import style0 from "./ImageDetailsStepFour.vue?vue&type=style&index=0&id=4b5af929&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5af929",
  null
  
)

export default component.exports